import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AccessRightDTO } from '@peartherapeutics/hylia-api-client';
import { iframePostMessage } from 'utils/constants';
import appRoutes from 'utils/routes';

import { sessionGet, SessionKeys } from 'utils/tokenStorage';
import AccessCode from '../AccessCode';
import TabBar from '../TabBar';

const MainBody = ({ accessRight }: { accessRight: AccessRightDTO }) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { pathname } = useLocation();

  const postUpdateParentHeightIframe = () => {
    const iframeHeightRoot = window.document.getElementById('root');
    if (window && window.parent && iframeHeightRoot) {
      const iframeHeight = iframeHeightRoot.clientHeight;
      window.parent.postMessage(
        {
          payload: {
            action: iframePostMessage.UPDATE_CONTENT_HEIGHT,
            contentHeight: iframeHeight,
          },
        },
        sessionGet(SessionKeys.ORIGIN)!,
      );
      // Make sure parent height already updated before show the iframe content
      setTimeout(() => setIsLoading(false), 1000);
    }
  };

  const updateHeightForParentWindow = useCallback(() => {
    let element = null;
    let routes = appRoutes();
    if (pathname === routes.PATIENT_DASHBOARD_OVERVIEW) {
      element = document.querySelector('#overview-tab-id');
    } else if (pathname === routes.PATIENT_DASHBOARD_LESSONS) {
      element = document.querySelector('#lessons-tab-id');
    } else if (pathname === routes.PATIENT_DASHBOARD_REWARDS) {
      element = document.querySelector('#rewards-tab-id');
    } else if (pathname === routes.PATIENT_DASHBOARD_CALENDAR) {
      element = document.querySelector('#calendar-tab-id');
    } else if (pathname === routes.PATIENT_DASHBOARD_CRAVINGS) {
      element = document.querySelector('#cravings-tab-id');
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          postUpdateParentHeightIframe();
        }
      });
    });

    if (element !== null) {
      observer.observe(element, {
        attributes: true,
        attributeFilter: ['data-testid'],
      });
    } else {
      // When there is no tab rendered, in particular, it is accessCode component
      setTimeout(() => {
        postUpdateParentHeightIframe();
      }, 1000);
    }

    return () => {
      observer.disconnect();
    };
  }, [pathname]);

  useEffect(() => {
    updateHeightForParentWindow();
    setIsLoading(true);
  }, [pathname, updateHeightForParentWindow, accessRight]);

  if (accessRight.status === 'new')
    return <AccessCode accessCode={accessRight.accessCode} />;
  return <TabBar isLoading={isLoading} />;
};

export default MainBody;
